export const TermsData = [
  {
    name: "Term and Conditions",
    content: `Refund Policy - No Refund - In case of any calamities / rains / fire or other mishaps and legal hurdles, which may cause change of time, cancellation or part
    cancellation of the festival, the amount is non-refundable`,
  },
];
